import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { InspectionFolder } from '../../shared/models/index';

@Component({
    selector: 'new-folder',
    templateUrl: './new.component.html',
    standalone: false
})
export class NewFolderComponent implements OnInit {
  public folder: InspectionFolder = new InspectionFolder('', 'new folder', '');
  @Output() public toggleCreateFolder: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  @Input() public processing;

  editForm: UntypedFormGroup;
  ngOnInit(): void {}

  public save() {
    this.toggleCreateFolder.emit(this.folder);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
